import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AlertState {
  message?: string;
  type?:
  | "dark"
  | "error"
  | "info"
  | "light"
  | "primary"
  | "secondary"
  | "success"
  | "warning";
  visible?: boolean;
  size?: "large" | "small";
}

const initialState: AlertState = {
  message: "",
  type: undefined,
  visible: false,
  size: "large",
};

const alertSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    showAlert: (
      state,
      action: PayloadAction<AlertState>
    ) => {
      state.message = action.payload.message;
      state.type = action.payload.type;
      state.visible = true;
    },
    hideAlert: (state) => {
      state.message = "";
      state.type = undefined;
      state.visible = false;
    },
  },
});

export const { showAlert, hideAlert } = alertSlice.actions;
export default alertSlice.reducer;
